import React, { useEffect, useState } from 'react';

import moment from "moment";
import { Button, Table, Tooltip } from "antd";
import axios from '../../util/Api'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import { Link } from 'react-router-dom';
import './style.css'
function DeviceMapTable(props) {
    const [tableData, setTableData] = useState([])
    const [fuelLevels, setFuelLevels] = useState({}) // Store fuel levels by device ID
    const [manualMeterReadingCache, setManualMeterReadingCache] = useState({})
    const [manualHoursReadingCache, setManualHoursReadingCache] = useState({})
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10
    })

    // console.log(props.assets)

    useEffect(() => {
        // console.log('props =>', props.devicePositionalData);
        const data = props.devicePositionalData || []
        const tableData = data.map(item => {
            const { deviceMaps, dData, dId } = item || {}
            // console.log('dData =>', dData);
            const asset = deviceMaps.get(dId) || {}
            return {
                assetId: asset._id || '',
                deviceId: dId,
                assetCode: asset.assetCode || '',
                assetModel: asset && asset.assetModel && asset.assetModel.name || '',
                altName: asset.altName || '',
                owner: asset.ownerCode || '',
                location: asset.location && asset.location.name || '',
                subLocation: asset.client && asset.client.name || '',
                lat_long: dData.lat_long || '',
                bat_vol: dData.bat_vol && dData.bat_vol.replace('Voltage', 'V') || '',
                status: dData.status || '',
                timestamp: dData.timestamp || '',
                meter: dData.meter || '',
                hours: dData.ignition_on_counter || '',
                fuel_level_analog: dData.fuel_level_analog || 0,
            }
        })
        setTableData(tableData)
    }, [props.devicePositionalData])

    const fetchFuelLevels = React.useCallback(async (currentTableData) => {
        const fuelPromises = currentTableData.map(row => {
            // console.log('row =>', row);
            let deviceId = row.deviceId;
            if (row.deviceId.includes('-')) {
                const [deviceImei, _] = row.deviceId.split('-');
                deviceId = deviceImei;
            }
            return axios.get(`/asset-fuel-sensor-calibration/calculate-liters/${row.assetId}/${deviceId}/${row.fuel_level_analog}`)
                .then(response => {
                    // console.log(row.assetId + ' response =>', response.data);
                    return ({
                        assetId: row.assetId,
                        fuelLevel: response.data && Number(response.data).toFixed(2) || '-'
                    })
                })
                .catch(error => {
                    console.error(`Error fetching fuel level for device ${row.assetId}:`, error)
                    return { assetId: row.assetId, fuelLevel: '-' }
                })
        })

        try {
            const results = await Promise.all(fuelPromises)
            const newFuelLevels = results.reduce((acc, { assetId, fuelLevel }) => {
                acc[assetId] = fuelLevel
                return acc
            }, {})
            setFuelLevels(newFuelLevels)
        } catch (error) {
            console.error('Error fetching fuel levels:', error)
        }
    }, [])

    const fetchManualMeterReading = React.useCallback(async (currentTableData) => {
        // console.log('fetchManualMeterReading =>', currentTableData)
        const manualMeterReadingPromises = currentTableData.map(row => {
            // console.log('row =>', row)
            const asset = props.assets.find(a => a._id === row.assetId)
            // console.log('asset =>', asset)
            if (asset && asset.assetModel && asset.assetModel.meters && asset.assetModel.meters.length) {
                const meterKM = asset && asset.assetModel && asset.assetModel.meters && asset.assetModel.meters.length && asset.assetModel.meters.filter(m => m.name === 'KMS')
                const meterHours = asset && asset.assetModel && asset.assetModel.meters && asset.assetModel.meters.length && asset.assetModel.meters.filter(m => m.name === 'HOURS')
                // console.log('meterKM =>', meterKM)
                if (meterKM && meterKM.length && meterKM[0]._id) {
                    const key = `${row.assetId}-${meterKM[0]._id}-${moment().valueOf()}`
                    // console.log('key =>', key)
                    if (key in manualMeterReadingCache) {
                        // console.log('cache hit')
                        return manualMeterReadingCache[key]
                    } else {
                        // console.log('cache miss')
                        axios.get(`/manual-asset-reading/last-reading-with-time/${row.assetId}/${meterKM[0]._id}/${moment().valueOf()}`)
                            .then(response => {
                                // console.log(row.assetId + ' response =>', response.data);
                                const { _id, reading, timestamp, lastIotReading } = response.data || {}
                                manualMeterReadingCache[row.assetId] = Number(reading) - (Number(lastIotReading) / 1000)
                                return;//manualMeterReadingCache[row.assetId]
                            })
                            .catch(error => {
                                console.error(`Error fetching manual meter reading for device ${row.assetId}:`, error)
                                return //{ assetId: row.assetId, meterReading: '-' }
                            })
                    }
                }
                if (meterHours && meterHours.length && meterHours[0]._id) {
                    const key = `${row.assetId}-${meterHours[0]._id}-${moment().valueOf()}`
                    if (key in manualHoursReadingCache) {
                        return manualHoursReadingCache[key]
                    } else {
                        axios.get(`/manual-asset-reading/last-reading-with-time/${row.assetId}/${meterHours[0]._id}/${moment().valueOf()}`)
                            .then(response => {
                                // console.log(row.assetId + ' response  hrs=>', response.data);
                                const { _id, reading, timestamp, lastIotReading } = response.data || {}
                                manualHoursReadingCache[row.assetId] = Number(reading) - (Number(lastIotReading) / 3600)
                                return;//manualHoursReadingCache[row.assetId]
                            })
                            .catch(error => {
                                console.error(`Error fetching manual hours reading for device ${row.assetId}:`, error)
                                return //{ assetId: row.assetId, hoursReading: '-' }
                            })
                    }
                }
            }
        })
        await Promise.all(manualMeterReadingPromises)
    }, [])

    // useEffect(() => {
    //     console.log('tableData =>', tableData)
    //     tableData.forEach(row => {
    //         const asset = props.assets.find(a => a._id === row.assetId)
    //         if (asset && asset.assetModel && asset.assetModel.meters && asset.assetModel.meters.length) {
    //             const meterId = asset && asset.assetModel && asset.assetModel.meters && asset.assetModel.meters.length && asset.assetModel.meters.filter(m => m.name === 'KMS')
    //             console.log(meterId)

    //         }
    //     })
    // }, [tableData, props.assets])

    // useEffect(() => {
    //     console.log('manualMeterReadingCache =>', manualMeterReadingCache)
    // }, [manualMeterReadingCache])

    // Separate effect for fuel level fetching
    useEffect(() => {
        // console.log('tableData =>11 ', tableData)
        if (tableData.length > 0) {
            fetchFuelLevels(tableData)
            fetchManualMeterReading(tableData)
        }
    }, [tableData, fetchFuelLevels, fetchManualMeterReading])

    const handleDownload = () => {
        // console.log('handleDownload triggered')
        // console.log('Current tableData:', tableData)
        // console.log('Current fuelLevels:', fuelLevels)

        if (!tableData || tableData.length === 0) {
            console.log('No data available to download')
            return
        }

        try {
            // Prepare data for excel
            const excelData = tableData.map(row => ({
                'Asset Code': row.assetCode,
                'Asset Model': row.assetModel || '-',
                'Alt Name': row.altName,
                'Owner Code': row.owner,
                'Location': row.location,
                'Sub Location': row.subLocation,
                'Status': row.status,
                'Last Updated': row.timestamp && moment(row.timestamp).format('DD-MM-YYYY HH:mm:ss') || '-',
                'Lat Lng': row.lat_long,
                'Battery Voltage': row.bat_vol,
                'Meter Reading (Kms)': manualMeterReadingCache[row.assetId] ? `${Number(manualMeterReadingCache[row.assetId]) + parseFloat((row.meter && row.meter.replace(/[^0-9.]/g, '')) || '0')} *` : row.meter,
                'Meter Reading (Hours)': row.hours,
                'Fuel Level (Analog)': row.fuel_level_analog,
                'Fuel Level (Liters)': fuelLevels && fuelLevels[row.assetId] || '-'
            }))

            // console.log('Prepared excelData:', excelData)

            // Create worksheet
            const ws = XLSX.utils.json_to_sheet(excelData)

            // Create workbook
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, ws, 'Device Data')

            // Generate excel file
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
            const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })

            // Download file
            const fileName = `device-data-${moment().format('YYYY-MM-DD-HH-mm-ss')}.xlsx`
            // console.log('Attempting to download file:', fileName)
            saveAs(data, fileName)
        } catch (error) {
            console.error('Error in handleDownload:', error)
        }
    }

    const columns = [
        {
            title: 'Sl.',
            dataIndex: 'sl',
            key: 'sl',
            render: (text, record, index) => {
                return <span>{(pagination.current - 1) * pagination.pageSize + index + 1}</span>
            },
            width: 50
        },
        {
            title: 'Asset Code',
            dataIndex: 'assetCode',
            key: 'assetCode',
            sorter: (a, b) => a.assetCode.localeCompare(b.assetCode),
            render: (text, record) => {
                const deviceId = record.deviceId.includes('-') ? record.deviceId.split('-')[0] : record.deviceId;
                // Owner / alt name on its own line, only the parts that exist
                const subText = [record.owner, record.altName].filter(Boolean).join('/')
                return (<>
                    <Link target='_blank' to={`/iot/device-details/${record.assetId}/${deviceId}`}>{record.assetCode}</Link>
                    {subText && <small style={{ display: 'block' }}>{subText}</small>}
                </>)
            },
            width: 150
        },
        // {
        //     title: 'Owner Code',
        //     dataIndex: 'owner',
        //     key: 'owner',
        //     sorter: (a, b) => a.owner.localeCompare(b.owner),
        //     render: (text, record) => {
        //         return <span>{record.owner}</span>
        //     },
        //     width: 100
        // },
        {
            title: 'Asset Model',
            dataIndex: 'assetModel',
            key: 'assetModel',
            sorter: (a, b) => (a.assetModel || '').localeCompare(b.assetModel || ''),
            render: (text, record) => {
                return <span>{record.assetModel || '-'}</span>
            },
            width: 150
        },
        {
            title: 'Location',
            dataIndex: 'location',
            key: 'location',
            sorter: (a, b) => a.location.localeCompare(b.location),
            width: 110
        },
        {
            title: 'Sub Location',
            dataIndex: 'subLocation',
            key: 'subLocation',
            sorter: (a, b) => a.subLocation.localeCompare(b.subLocation),
            width: 120
        },
        {
            title: 'Last Updated',
            dataIndex: 'timestamp',
            key: 'timestamp',
            sorter: (a, b) => {
                const timeA = moment(a.timestamp)
                const timeB = moment(b.timestamp)
                return timeA.valueOf() - timeB.valueOf()
            },
            render: (timestamp) => {
                return <span>{timestamp && moment(timestamp).format('DD-MM-YYYY HH:mm:ss') || '-'}</span>
            },
            width: 110
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            sorter: (a, b) => a.status.localeCompare(b.status),
            render: (status) => {
                return <Tooltip title={status}><span><img src={require(`assets/images/icon/${status}.png`)} alt={status} title={status} /></span></Tooltip>
            },
            width: 80
        },
        {
            title: 'Lat Lng',
            dataIndex: 'lat_long',
            key: 'lat_long',
            sorter: (a, b) => a.lat_long.localeCompare(b.lat_long),
            width: 120
        },
        {
            title: 'Battery Voltage',
            dataIndex: 'bat_vol',
            key: 'bat_vol',
            sorter: (a, b) => {
                const numA = parseFloat((a.bat_vol && a.bat_vol.replace(/[^0-9.]/g, '')) || '0')
                const numB = parseFloat((b.bat_vol && b.bat_vol.replace(/[^0-9.]/g, '')) || '0')
                return numA - numB
            },
            width: 100
        },
        {
            title: 'Meter Reading (Kms)',
            dataIndex: 'meter',
            key: 'meter',
            sorter: (a, b) => {
                const numA = parseFloat((a.meter && a.meter.replace(/[^0-9.]/g, '')) || '0')
                const numB = parseFloat((b.meter && b.meter.replace(/[^0-9.]/g, '')) || '0')
                return numA - numB
            },
            render: (meter, record) => {
                return <span>{manualMeterReadingCache[record.assetId] ? `${(Number(manualMeterReadingCache[record.assetId]) + parseFloat((meter && meter.replace(/[^0-9.]/g, '')) || '0')).toFixed(2)} *` : meter}</span>
            },
            width: 130
        },
        {
            title: 'Meter Reading (Hours)',
            dataIndex: 'hours',
            key: 'hours',
            sorter: (a, b) => {
                const numA = parseFloat((a.hours && a.hours.replace(/[^0-9.]/g, '')) || '0')
                const numB = parseFloat((b.hours && b.hours.replace(/[^0-9.]/g, '')) || '0')
                return numA - numB
            },
            render: (hours, record) => {
                // console.log('hours =>', hours, record);
                return <span>{manualHoursReadingCache[record.assetId] ? `${(Number(manualHoursReadingCache[record.assetId]) + parseFloat((hours && hours.replace(/[^0-9.]/g, '')) || '0')).toFixed(2)} *` : hours}</span>
            },
            width: 110
        },
        {
            title: 'Fuel Level',
            dataIndex: 'fuel_level_analog',
            key: 'fuel_level_analog',
            sorter: (a, b) => {
                const fuelA = fuelLevels && fuelLevels[a.assetId]
                const fuelB = fuelLevels && fuelLevels[b.assetId]
                // Only sort if both values are loaded
                if (fuelA && fuelB && !!Number(fuelA) && !!Number(fuelB)) {
                    return Number(fuelA) - Number(fuelB)
                }
                return 0 // Don't change order if values aren't loaded
            },
            sortDirections: ['ascend', 'descend', 'ascend'],
            showSorterTooltip: false,
            render: (fuel_level_analog, record) => {
                return (
                    <span>
                        {fuelLevels && fuelLevels[record.assetId] && !!Number(fuelLevels[record.assetId])
                            ? `${Number(fuelLevels[record.assetId]).toFixed(2)} ltr.`
                            // : <span title='Fuel Sensor data' style={{ color: 'red' }}>{fuel_level_analog}</span>}
                            : <span title='Fuel Sensor data' style={{ color: 'red' }}></span>}
                    </span>
                )
            },
            width: 100
        }
    ]
    // With a fixed header (scroll.y) antd v3 renders header and body as separate tables, so every
    // column needs a width and scroll.x must equal their total, or the columns do not line up.
    const tableScrollX = columns.reduce((total, column) => total + (column.width || 0), 0)

    return (

        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Table
                className="device-map-table"
                dataSource={tableData}
                columns={columns}
                bordered
                size='small'
                scroll={{ y: 400, x: tableScrollX }}
                rowKey={(record) => record.deviceId}
                pagination={{
                    size: 'small',
                    total: tableData.length,
                    pageSize: pagination.pageSize,
                    current: pagination.current,
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                    onChange: (page, pageSize) => {
                        setPagination({ current: page, pageSize })
                    }
                }}
                footer={() => (
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        <div>
                            <Button
                                type="default"
                                onClick={handleDownload}
                                disabled={!tableData.length}
                                icon="download"
                            >
                                Download Excel
                            </Button>
                        </div>
                        <div className="ant-table-pagination ant-table-pagination-right">
                            {/* Pagination will automatically render here */}
                        </div>
                    </div>
                )}
            />
        </div>
    );
}

export default DeviceMapTable;
